import React, { useEffect, useState } from "react";

// Wide banner above a deck block. Two or more photos cross-fade on a timer.
export function Banner({ photos = [], alt = "", testid = "ir-banner" }) {
  const pics = photos.filter(Boolean);
  const [i, setI] = useState(0);
  useEffect(() => {
    if (pics.length < 2) return;
    const iv = setInterval(() => setI((n) => (n + 1) % pics.length), 6000);
    return () => clearInterval(iv);
  }, [pics.length]);
  if (!pics.length) return null;
  return (
    <div className="ir-banner" data-testid={testid}>
      {pics.map((src, n) => (
        <img key={src} src={src} alt={alt} className={n === i % pics.length ? "on" : ""} data-testid={`${testid}-img-${n}`} />
      ))}
      {pics.length > 1 && (
        <div className="ir-banner-dots" data-testid={`${testid}-dots`}>
          {pics.map((src, n) => (
            <button key={src} className={n === i % pics.length ? "on" : ""} onClick={() => setI(n)} aria-label={`Photo ${n + 1}`} data-testid={`${testid}-dot-${n}`} />
          ))}
        </div>
      )}
    </div>
  );
}
